
<div cdkDrag  cdkDragBoundary=".cdk-overlay-container"  cdkDragRootElement=".cdk-overlay-pane">
<ng-container  *ngIf="data.id">
    <div  cdkDragHandle  style="  cursor: move;" fxLayout="row wrap" fxLayoutAlign="space-between center" >
<!--        <div fxLayout="row wrap" fxLayoutAlign="space-between start"  class="dialog-headline">-->
            <h2 mat-dialog-title class="dialog-title">{{'Participation à appel offres' | translate}}</h2>
            <button  mat-dialog-close mat-icon-button class="dialog-close-btn">
                <mat-icon>close</mat-icon>
            </button>
<!--        </div>-->

    </div>

    <div mat-dialog-content  >



        <div fxFlex="100" fxFlex.gt-sm="100" style="max-width: 100%;justify-content: center;" *ngIf="data.id">

            <app-tree-table [publicationAO]="false" [canupload]="data?.canupload" [withfile]="true" (dataselectedwithfile)="senddatawithfile($event)" [withcheckbok]="true" [id]="data.id"  (dataselected)="send($event)" [isPqTp]="inputData.isPqTp"></app-tree-table>
        </div>
    </div>
    <div class="pc" mat-dialog-actions fxLayoutAlign="end end">
        <div fxLayout="row wrap" fxLayoutAlign="center center" *ngIf="data.isgroupement">
            <button  (click)="listgroupement()" color="primary" mat-raised-button type="submit">
                {{ "consulter_groupement" | translate }}
            </button>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button [disabled]="listchecked.length==0" (click)="onSuccessAdd()" color="primary" mat-raised-button type="submit">
                {{ "Rédaction" | translate }}
            </button>
        </div>


    </div>
</ng-container>

</div>
